import request from '@/utils/request'

export function checkAddRecord (clazzId) {
  return request({
    url: '/front/clazz/' + clazzId + '/daka/check/',
    method: 'get'
  })
}

export function addRecord (data) {
  return request({
    url: '/front/daka/',
    method: 'post',
    data
  })
}

export function getRecordPoster (params) {
  return request({
    url: '/front/daka/poster/',
    method: 'get',
    params
  })
}

export function setRecordPoster (data) {
  return request({
    url: '/front/daka/poster/',
    method: 'put',
    data
  })
}

export function getRecordPosterData (params) {
  return request({
    url: '/front/daka/poster/data/',
    method: 'get',
    params
  })
}

export function cycleRecordFullList (cycleId, query) {
  return request({
    url: '/front/clazz/cycle/' + cycleId + '/record/full/list/',
    method: 'get',
    params: query
  })
}

export function clazzRecordStat (clazzId, query) {
  return request({
    url: '/front/clazz/' + clazzId + '/record/stat/',
    method: 'get',
    params: query
  })
}

export function myRecordStat () {
  return request({
    url: '/front/my/record/stat/',
    method: 'get'
  })
}

export function userClazzStat (clazzId, userId) {
  return request({
    url: '/front/clazz/' + clazzId + '/user/' + userId + '/stat/',
    method: 'get'
  })
}

export function userClazzMonthStat (clazzId, userId, day) {
  return request({
    url: '/front/clazz/' + clazzId + '/user/' + userId + '/month/stat/',
    method: 'get',
    params: { day }
  })
}

export function userClazzDayRecord (clazzId, userId, day) {
  return request({
    url: '/front/clazz/' + clazzId + '/user/' + userId + '/day/record/',
    method: 'get',
    params: { day }
  })
}

export function userRecordList (query) {
  return request({
    url: '/front/user/record/full/list/',
    method: 'get',
    params: query
  })
}

export function recordInfo (recordId) {
  return request({
    url: '/front/record/' + recordId + '/info/',
    method: 'get'
  })
}

export function reviewRecordOne (clazzId, query) {
  return request({
    url: '/front/clazz/' + clazzId + '/review/record/one/',
    method: 'get',
    params: query
  })
}

export function recordReview (recordId, data) {
  return request({
    url: '/front/record/' + recordId + '/review/',
    method: 'put',
    data
  })
}

export function recordRepass (recordId, data) {
  return request({
    url: '/front/record/' + recordId + '/repass/',
    method: 'put',
    data
  })
}

export function recordDelete (recordId) {
  return request({
    url: '/front/record/' + recordId + '/delete/',
    method: 'delete'
  })
}
